import type { DomainDto } from 'common/interfaces/domains';

export const utilGetDomainsExplanation = (
  currentDomainId: number | string,
  domains: DomainDto[] = [],
) => {
  const currentDomainData = domains.find((d) => d.id === Number(currentDomainId));
  let domainsString = '';
  let allowedDomains: DomainDto[] = [];

  if (currentDomainData && !currentDomainData.settings?.showAllPages) {
    domainsString = currentDomainData?.name;
    allowedDomains = [currentDomainData];
  } else {
    allowedDomains = domains.filter((d) => d.settings?.showAllPages);
    domainsString = allowedDomains.map((d) => d.name).join(', ');
  }

  const domainExplanation = `Domain is an optional value. ${
    currentDomainId
      ? `If you choose ${currentDomainData?.name}`
      : "If you don't choose domain option"
  } page will appear on the next domains: ${domainsString}`;

  return {
    allowedDomains,
    domainExplanation,
  };
};
